export default __webpack_public_path__ + "static/media/newbie_project8.338cc43b.jpg";